import { Box } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Form } from "@samdesk/components/Form";
import { Heading } from "@samdesk/components/Heading";
import { InputText } from "@samdesk/components/InputText";
import { Stack } from "@samdesk/components/Stack";
import { Text } from "@samdesk/components/Text";
import { messageSx, wrapperSx } from "router/authStyles";
import { withErrorBoundary } from "utils/ErrorBoundary";

import useController from "./useController";

const Index = () => {
	const { errorMessage, handleSubmitMFACode } = useController();

	return (
		<Box sx={wrapperSx}>
			<Stack spacing="large">
				<Stack spacing="base">
					<Heading level="1">Two-factor authentication</Heading>
					<Text align="start" prominence="secondary">
						We have sent a two-factor authentication code to your email address.
						Enter the code below to continue.
					</Text>
					<Text align="start" prominence="secondary">
						If you did not see the email, please check your spam folder or
						contact your account admin.
					</Text>
				</Stack>

				<Form onSubmit={handleSubmitMFACode}>
					<Stack spacing="large">
						<Stack spacing="base">
							<InputText
								autoComplete="one-time-code"
								label="Code"
								name="code"
								rules={{ required: "Code is required" }}
							/>
							{errorMessage && (
								<Box sx={messageSx}>
									<Text accent="error">{errorMessage}</Text>
								</Box>
							)}
						</Stack>
						<Button fullWidth label="Sign in" prominence="primary" submit />
					</Stack>
				</Form>
			</Stack>
		</Box>
	);
};

export default withErrorBoundary(Index);
